import { getCountries, getCountryCallingCode, CountryCode } from "libphonenumber-js";

/**
 * Format a raw phone string (digits only, e.g. "971501234567") into
 * "+<country_code> <local_number>" display format (e.g. "+971 501234567").
 *
 * Works by matching the longest known country dial code prefix.
 * Falls back to prepending "+" if no match is found.
 */
export function formatPhoneDisplay(raw: string | number | undefined | null): string {
  if (!raw && raw !== 0) return "";
  let phone = String(raw).replace(/[^\d]/g, ""); // strip to digits only
  if (!phone) return "";

  // Build sorted list of dial codes (longest first for greedy match)
  const countries = getCountries();
  const dialCodes: { code: string; country: CountryCode }[] = countries.map((c) => ({
    code: getCountryCallingCode(c),
    country: c,
  }));

  // Sort by length descending so longer codes match first (e.g. +971 before +97 before +9)
  dialCodes.sort((a, b) => b.code.length - a.code.length);

  for (const { code } of dialCodes) {
    if (phone.startsWith(code)) {
      const local = phone.slice(code.length);
      return `+${code} ${local}`;
    }
  }

  // Fallback: just prepend +
  return `+${phone}`;
}
